import { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom"
import { CartContext } from "../context/CartContext"
import "./WooProducts.css"

function WooProducts({ search, categoryId = "", categoryName = "Our Products" }) { 
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const { addToCart } = useContext(CartContext)

  useEffect(() => {
    setLoading(true)
    let url = `https://data.lacegota.in/api/products?per_page=30`;
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (categoryId) {
      url += `&category=${categoryId}`;
    }

    fetch(url)
      .then(res => res.json())
      .then(data => {
        setProducts(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error:", err);
        setLoading(false);
      });
  }, [search, categoryId]);

  if (loading) return <div className="amazon_loader">Loading Products...</div>

  return (
    <div className="wooSection">
      {/* Dynamic Title Section */}
      <div className="wooHeader">
        <h2 className="wooMainTitle">
          {search ? `Search Results for "${search}"` : categoryName}
        </h2>
        <p className="wooSubtitle">{products.length} Products found</p>
      </div>

      <div className="wooGrid">
        {products.map(product => {
          // --- Price & Discount Logic ---
          const mktPrice = parseFloat(product.regular_price || 0);
          const salePrice = parseFloat(product.price || 0);
          const discount = mktPrice > salePrice 
            ? Math.round(((mktPrice - salePrice) / mktPrice) * 100) 
            : 0;

          // --- Color Logic ---
          const colorAttr = product.attributes?.find(a => a.name.toLowerCase() === "color");
          const colorName = colorAttr ? colorAttr.options[0] : "Detected";

          return (
            <div className="wooCard" key={product.id}>
              <div className="imageBox">
                <span className="hotBadge">Best Seller</span>
                <button className="wishlistBtn">❤</button>
                
                <Link to={`/product/${product.slug}`} className="productImageLink">
                  <img 
                    src={product.images?.[0]?.src || "/placeholder.jpg"} 
                    alt={product.name} 
                    className="productImg"
                  />
                </Link>
              </div>

              <div className="cardContent">
                <Link to={`/product/${product.slug}`} className="titleLink">
                   <h3 className="productTitle">{product.name}</h3>
                </Link>

                {/* 🎨 Color Metadata */}
                <div className="pMeta">Color: {colorName}</div>

                <div className="ratingRow">⭐⭐⭐⭐ 4.5</div>

                {/* 💰 Amazon Style Price Section */}
                <div className="priceContainer">
                    <div className="mainPriceRow">
                        {discount > 0 && <span className="pPercentage">-{discount}%</span>}
                        <span className="pCurrency">₹</span>
                        <span className="pPriceBold">{salePrice}</span>
                    </div>
                    {mktPrice > salePrice && (
                        <div className="mktPriceRow">
                            M.R.P.: <span className="pStrike">₹{mktPrice}</span>
                        </div>
                    )}
                </div>

                <button className="cartBtn" onClick={() => addToCart(product, 1)}>
                  Add to Cart
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default WooProducts;